import {
  GET_SUPERVISORS_FAIL,
  GET_SUPERVISORS_START,
  GET_SUPERVISORS_SUCCESS,
  MODIFY_SUPERVISORS_FAIL,
  MODIFY_SUPERVISORS_SUCCESS,
  SUPERVISORS_CANCEL_BULK_ACTION,
  SUPERVISORS_REFRESH,
  SUPERVISORS_SET_LOADING,
} from 'actions/userProfile';

import {
  getListPageSuccessNewData,
  getListPageSuccessNewLinks,
} from '../utils';

const defaultState = {
  loading: true,
  data: [],
  links: {},
  dataLoaded: false,
  error: false,
  shouldCancel: false,
  currentUserId: null,
};

export default function supervisors(state = defaultState, action) {
  switch (action.type) {
    case GET_SUPERVISORS_START: {
      const newState = {
        ...state,
        dataLoaded: false,
        currentUserId: action.currentUserId,
      };
      if (state.currentUserId !== action.currentUserId) {
        newState.loading = true;
        newState.data = [];
      }
      return newState;
    }
    case GET_SUPERVISORS_SUCCESS: {
      const { data, links, total } = action.payload;

      return {
        ...state,
        ...{
          data: getListPageSuccessNewData(state, data, links),
          links: getListPageSuccessNewLinks(links),
          total,
          dataLoaded: true,
          loading: false,
          error: false,
        },
      };
    }
    case SUPERVISORS_SET_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case SUPERVISORS_REFRESH: {
      return {
        ...state,
        data: [], // Require reload
        loading: true,
      };
    }
    case GET_SUPERVISORS_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case SUPERVISORS_CANCEL_BULK_ACTION: {
      return {
        ...state,
        shouldCancel: true,
      };
    }
    case MODIFY_SUPERVISORS_FAIL:
    case MODIFY_SUPERVISORS_SUCCESS: {
      return {
        ...state,
        shouldCancel: false,
      };
    }
    default:
      return state;
  }
}
